export default __webpack_public_path__ + "static/coin-efd1e22fef306901b6e798c0d1db5c5b.png";